@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);

<div class="d-flex">
  @if (
    {
      isQuickActivityDraggable:
        createNewViaDragAndDropService.isNewActivityQuickActionCardDraggable$
        | async,
      areActivitiesVisible: areActivitiesVisible$ | async,
    };
    as data
  ) {
    <div
      class="activity-card d-flex text-truncate"
      [class.hide-card]="!isQuickCreationCardOpen"
      [class.not-allowed]="
        !hasShiftUpdatePermission ||
        disabled ||
        !data.isQuickActivityDraggable ||
        !data.areActivitiesVisible
      "
      [draggable]="
        hasShiftUpdatePermission &&
        !disabled &&
        data.isQuickActivityDraggable &&
        data.areActivitiesVisible
      "
      nz-tooltip
      [nzTooltipTitle]="
        !hasShiftUpdatePermission
          ? ('general.forbidden_action' | translate)
          : null
      "
      (dragstart)="startDrag()"
      (dragend)="dragEnd()"
      data-test-id="wilson-new-activity-quick-creation-card"
    >
      <div class="d-block">
        <p class="mb-2 fw-normal text-dark card-text">
          {{ 'page.shift_timeline.empty_activity' | translate }}
        </p>
      </div>
    </div>
  }
</div>
